export default "__VITE_ASSET__BAYPlOjP__"